import { InstagramAccount } from 'apps/instagram/models/interfaces'
import { getUserRole, UserRoles } from 'common/userRoles'

export const getAccountsFetching = (state: RootState): boolean => {
  return state.instagram.accountsFetching
}

export const getAccountsFetched = (state: RootState): boolean => {
  return state.instagram.accounts !== null
}

export const getConnectedInstagramAccounts = (state: RootState): InstagramAccount[] | null => {
  return state.instagram.accounts
}

export const getToggleChannelFetching = (state: RootState): boolean => {
  return state.instagram.toggleChannelFetching
}

export const havePermissionsToConnectIG = (state: RootState): boolean => {
  const userRole = getUserRole(state)
  return userRole === UserRoles.ADMIN || userRole === UserRoles.OWNER
}
